"use strict";
window['Apex'] || (window['Apex'] = {});
; (function (namespace, $, undefined)
{
	namespace.showSpinner = function()
	{
		if (window.location.href.indexOf("orderdetails") <= -1)
		{
			$('#spinner').show();
			window.setTimeout(function ()
			{
				namespace.hideSpinner();
			}, 20000);
		}
	}

	namespace.hideSpinner = function()
	{
		$('#spinner').hide();
	}

	window.showSpinner = () => namespace.showSpinner()

	// Redirect wrapper
	namespace.redirect = function (url)
	{
		showSpinner();
		window.location.href = url;
	}

	// Custom alert dialog
	namespace.alert = function (message, title, callback)
	{
		title = title || '';
		callback = callback || $.noop;

		bootbox.dialog(
			{
				closeButton: false,
				message: message,
				title: title,
				buttons:
				{
					success:
					{
						label: 'OK',
						className: 'btn btn-success',
						callback: callback
					}
				}
			});
	}

	// Show common error alert dialog
	namespace.alertError = function (message)
	{
		bootbox.dialog({ message: '<div class="alert alert-danger"><b>' + message + '</b></div>' });
	}

	// Handle common error statuses
	namespace.handleError = function (status, errors)
	{
		switch (status)
		{
			case 419: //ApplicationAuthorizeAttribute
				namespace.redirect('/login');
				break;
			case 500: //AjaxValidateAntiForgeryTokenAttribute
				namespace.alertError('The request is not valid.');
				break;
			case 0: //Incomplete/canceled request
				break;
			default:
				namespace.alertError(errors && errors.length ? errors[0].title : status);
		}
		hideSpinner();
	}

	namespace.ajaxIsSuccess = function (response)
	{
		return !!(response.Success || response.success
			|| (response.Success == undefined && response.success == undefined && !(response.errors && response.errors.length)));
	}

	// Common ajax success handler
	namespace.ajaxOnSuccess = function (response, textStatus, jqXHR)
	{
		if (namespace.ajaxIsSuccess(response))
		{
			namespace.alert(response.Message || response.msg);
		}
		else
		{
			namespace.alertError(response.Message || response.error);
		}
	}

	// Common ajax error handler
	namespace.ajaxOnError = function (jqXHR, textStatus, errorThrown)
	{
		var errors = (jqXHR.responseJSON && jqXHR.responseJSON.errors) ? jqXHR.responseJSON.errors : []; // JsonApi
		namespace.handleError(jqXHR.status, errors);
	}

	// Shortcut for common simple ajax post
	namespace.post = function (url, data, onSuccess, onError)
	{
		return $.ajax(
			{
				url: url,
				type: 'POST',
				data: data,
				success: onSuccess || namespace.ajaxOnSuccess,
				error: onError || namespace.ajaxOnError
			});
	}

	// Shortcut for common simple ajax get
	namespace.get = function (url, data, onSuccess, onError)
	{
		return $.ajax(
			{
				url: url,
				type: 'GET',
				data: data,
				success: onSuccess || namespace.ajaxOnSuccess,
				error: onError || namespace.ajaxOnError
			});
	}

	// Simple template parsing for an array of data
	namespace.parseTemplate = function (tpl, data)
	{
		var html = '';

		for (var i in data)
		{
			var _tpl = tpl;
			for (var _key in data[i])
			{
				_tpl = _tpl.replace(new RegExp('{' + _key + '}', 'gmi'), data[i][_key]);
			}
			html += _tpl;
		}

		return html;
	};

	namespace.isNumberKey = function (e, integer)
	{
		if (!integer)
			integer = false;

		let value = parseInt(e.target.value, 10)
		if (isNaN(value))
			return false

		var charCode = e.which || e.keyCode || e.charCode;
		var allowedKeys = [8, 9, 27, 13, 46, 110]
		if (!integer) allowedKeys.push(190)
		// Allow: backspace, delete, tab, escape, enter and .
		if ($.inArray(charCode, allowedKeys) !== -1 ||
			// Allow: Ctrl+A, Command+A
			(charCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
			// Allow: home, end, left, right, down, up
			(charCode >= 35 && charCode <= 40))
		{
			// let it happen, don't do anything
			return true;
		}
		// Ensure that it is a number and stop the keypress
		if ((e.shiftKey || (charCode < 48 || charCode > 57)) && (charCode < 96 || charCode > 105))
		{
			return false;
		}

		return true;
	}

	namespace.stopEvent = function (e)
	{
		e.preventDefault();
	}

	namespace.filterInput = function (e)
	{
		// Disallow < and > symbols
		this.value = this.value.replace(/[\"\'<>]/gi, '')
		// Disallow characters outside of the ASCII table
		this.value = this.value.replace(/[^\x00-\xFF]/g, '')
	}

	namespace.confirm = function (message, onConfirm, options)
	{
		if (!options)
			options = {};

		options = $.extend(true, {},
			{
				show: true,
				size: "small",
				message: message,
				title: "Please confirm:",
				buttons:
				{
					cancel:
					{
						label: "No",
						className: "btn btn-inverse"
					},
					confirm:
					{
						label: "Yes",
						className: "btn btn-default",
						callback: onConfirm
					}
				}
			},
			options)

		bootbox.hideAll();
		bootbox.dialog(options);
	};

	$(function ()
	{
		$('[data-action="addtocart"]').on('click', function (e)
		{
			e.preventDefault();

			var form = this.form || this,
				input = null,
				qty = 0,
				url = '',
				id = $(this).data('id') || 0;

			if (id)
			{
				input = $(':input[name$="EnteredQuantity"][data-id="' + id + '"]', form).first();
				qty = parseInt(input.val()) || 0;
				url = input.data('url');
			}

			if (qty)
			{
				$(this).prop('disabled', true).addClass('disabled');
				$('i.fa', this).first().addClass('fa-spin fa-spinner');
				var jqXHR = null

				if (url.substr(-2) == '/0')
				{
					jqXHR = AjaxCart.addproducttocart_catalog(url.replace('/0', '/' + qty))
				}
				else
				{
					jqXHR = AjaxCart.addproducttocart_details(url, form)
				}

				if (jqXHR)
				{
					jqXHR.always(function (data)
					{
						if (!data || !data.success)
						{
							$(this).prop('disabled', false).removeClass('disabled')
							$('i.fa', this).first().removeClass('fa-spin fa-spinner')
						}
					})
				}
			}
		});
	})
}(window.Apex, jQuery));
